(() => {
  const ROOT_SELECTOR = '[data-ld-z9-social]';
  const instances = new WeakMap();
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  class LDZ9SocialCommunity {
    constructor(root) {
      this.root = root;
      this.cards = Array.from(root.querySelectorAll('[data-social-card]'));
      this.rootObserver = null;
      this.cardObserver = null;
      this.destroyed = false;
      this.init();
    }

    init() {
      if (reducedMotionQuery.matches || !('IntersectionObserver' in window)) {
        this.showAll();
        return;
      }

      this.root.classList.add('is-motion-ready');

      this.rootObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.root.classList.add('is-inview');
            this.rootObserver?.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      this.cardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            this.cardObserver?.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      this.rootObserver.observe(this.root);
      this.cards.forEach((card) => {
        this.cardObserver.observe(card);
      });
    }

    showAll() {
      this.root.classList.add('is-inview');
      this.cards.forEach((card) => card.classList.add('is-inview'));
    }

    destroy() {
      this.destroyed = true;
      this.rootObserver?.disconnect();
      this.cardObserver?.disconnect();
      this.root.classList.remove('is-motion-ready');
      instances.delete(this.root);
    }
  }

  const initRoot = (root) => {
    if (!(root instanceof Element) || instances.has(root)) return;
    instances.set(root, new LDZ9SocialCommunity(root));
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);
  };

  const destroyAll = (scope) => {
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => instances.get(root)?.destroy());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:select', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));
})();
